import React, {useEffect, useState} from 'react';
import {Button, LogsTicketOld} from '@app/components/index';
import { Modal } from 'react-bootstrap';
import LogsTicketsService from '@app/services/logsTickets.service';

function ModalLogsRecorrido({show, hideModal, ticketId, ticketIdOld}) {
    const handleClose = () => hideModal();
    const [logsRecorrido, setlogsRecorrido] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if(ticketIdOld){
            setIsLoading(true);
            LogsTicketsService.getAll({logs: ticketIdOld, type:'cvv'}).then((data)=>{
                setlogsRecorrido(data)
            }).finally(()=> setIsLoading(false));
        }
    }, [])

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} size="md">
            <Modal.Header closeButton style={{borderBottom: '2px solid #dee2e6', padding: '12px 16px'}}>
                <Modal.Title style={{fontSize: '1rem', fontWeight: 600, color: '#343a40'}}>
                    <i className="fas fa-history mr-2 text-secondary" />
                    {`Recorrido del ticket #${ticketId}`}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body style={{background: '#f8f9fa', padding: '16px', maxHeight: '60vh', overflowY: 'auto', overflowX: 'hidden'}}>
                {isLoading && (
                    <div className="text-center py-4">
                        <i className="fas fa-spinner fa-spin text-secondary" style={{fontSize: '1.5rem'}} />
                        <p className="mt-2 text-muted small mb-0">Cargando historial...</p>
                    </div>
                )}
                {!isLoading && logsRecorrido.length > 0 && (
                    <div style={{position: 'relative', paddingLeft: '10px'}}>
                        <div
                            style={{
                                position: 'absolute',
                                left: '20px',
                                top: '14px',
                                bottom: '14px',
                                width: '1px',
                                background: '#dee2e6'
                            }}
                        />
                        {logsRecorrido.map((lg, index) => (
                            <LogsTicketOld
                                item={lg}
                                key={lg.id_lt || lg.id_tk}
                                handleClose={handleClose}
                                isLast={index === logsRecorrido.length - 1}
                            />
                        ))}
                    </div>
                )}
                {!isLoading && logsRecorrido.length === 0 && (
                    <div className="text-center py-4 text-muted">
                        <i className="fas fa-folder-open fa-2x mb-2 d-block" />
                        <span className="small">
                            {`El ticket #${ticketId} no tiene relacion con otro ticket.`}
                        </span>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer style={{borderTop: '1px solid #dee2e6', padding: '8px 16px'}}>
                <Button theme="default" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
export default ModalLogsRecorrido;
